import { Component, Input } from "@angular/core";

export type TContentType = 'video' | 'live-stream';

/**
 * Says whether a card is a video or the recording of a live stream. The two sit in one list
 * wherever content is browsed, and the kind is the first thing a reader sorts them by.
 */
@Component({
  selector: 'app-content-type-badge',
  templateUrl: "./content-type-badge.component.html",
  styleUrl: "./content-type-badge.component.scss",
})
export class ContentTypeBadgeComponent {
  @Input() type: TContentType = 'video';
}
